import {
    IconFacebook2, IconGoogleAds, IconOrganization, MainTheme,
} from '@paretogroup/tess';
import { PLATFORMS } from '@domain/platform/platform.types';

export const PLATFORM_ICONS = {
    [PLATFORMS.CLIENT]: IconOrganization,
    [PLATFORMS.GOOGLE_ADS]: IconGoogleAds,
    [PLATFORMS.FACEBOOK_ADS]: IconFacebook2,
};

export const ICON_COLORS_BY_PLATFORM = {
    [PLATFORMS.CLIENT]: {},
    [PLATFORMS.GOOGLE_ADS]: {
        primaryColor: MainTheme.colors['fun-blue'],
        secondaryColor: MainTheme.colors['fun-orange'],
    },
    [PLATFORMS.FACEBOOK_ADS]: {
        primaryColor: MainTheme.colors['fun-blue'],
    },
};
